export const DETAILS = "DETAILS"
export const REAST_DETAIL = "REAST_DETAIL"


// WEBPACK FOOTER //
// ./src/redux/type/CourseInfo.type.js